import { FAQSection } from "@components/FAQSection";
import { useCustomerData } from "@contexts/CustomerContext";
import { Container, Stack, Title } from "@repo/ui/core";

export function FAQPage() {
  const { faqs } = useCustomerData();

  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <Title order={2}>Frequently Asked Questions</Title>
        <FAQSection faqs={faqs} />
      </Stack>
    </Container>
  );
}
